import { Outlet } from "react-router-dom"
import { Box, useTheme } from "@mui/material"
import Div100vh from "react-div-100vh"

import { IAppLayoutProps } from "layouts/interface"
import { Header, HeaderLogo, HeaderTitle } from "components/Header"
import { Clock } from "components/Clock"
import { IndoorMapContainer } from "containers/IndoorMapContainer"
import { SearchContainer } from "containers/SearchContainer"
import { SearchPopupContent } from "components/domains/search/kiosk-h"

const PREFIX_CLASSNAME = "AppLayout"
export const AppLayoutClasses = {
  headerWrapper: `${PREFIX_CLASSNAME}-headerWrapper`,
  indoorMapWrapper: `${PREFIX_CLASSNAME}-indoorMapWrapper`,
  contentWrapper: `${PREFIX_CLASSNAME}-contentWrapper`,
}

const DEFAULT_HEADER = (
  <Header logo={<HeaderLogo />} title={<HeaderTitle />} clock={<Clock />} />
)
const DEFAULT_SEARCH = <SearchContainer renderComponent={SearchPopupContent} />

export const AppLayout: React.FC<IAppLayoutProps> = ({
  header = DEFAULT_HEADER,
  search = DEFAULT_SEARCH,
  appNavigation = null,
}) => {
  const theme = useTheme()
  const { styleOverrides = {} } = theme.components[`AppLayout`] || {}
  const {
    headerWrapper = {},
    contentWrapper = {},
    indoorMapWrapper = {},
  } = styleOverrides

  return (
    <Div100vh data-name="AppLayout">
      <Box sx={headerWrapper} className={AppLayoutClasses.headerWrapper}>
        {header || DEFAULT_HEADER}
      </Box>
      <Box sx={indoorMapWrapper} className={AppLayoutClasses.indoorMapWrapper}>
        <IndoorMapContainer />
      </Box>
      <Box sx={contentWrapper} className={AppLayoutClasses.contentWrapper}>
        <Outlet />
      </Box>
      {search || DEFAULT_SEARCH}
      {appNavigation && appNavigation}
    </Div100vh>
  )
}
